import {
  ENTITY,
  ENTITY_PATH,
  STYLED_COLUMN_HEADER_CLASSNAME,
  STYLED_COLUMN_TEXT_CLASSNAME,
} from '@constants'

export enum NAMES_OF_ENTITIES_FOR_STYLES {
  GLOBAL = 'GLOBAL',
  COLUMN = 'COLUMN',
  ENTITY = 'ENTITY',
}

const getClassNameGlobalStyles = (
  name: NAMES_OF_ENTITIES_FOR_STYLES,
  type: ENTITY,
  instanceId: string,
  columnCode?: string
) => {
  const modifyColumnField = columnCode?.replaceAll('.', '-')

  switch (name) {
    case NAMES_OF_ENTITIES_FOR_STYLES.GLOBAL:
      return {
        header: `${STYLED_COLUMN_HEADER_CLASSNAME}_${instanceId}`,
        text: `${STYLED_COLUMN_TEXT_CLASSNAME}_${instanceId}`,
      }
    case NAMES_OF_ENTITIES_FOR_STYLES.ENTITY:
      return {
        header: `${STYLED_COLUMN_HEADER_CLASSNAME}_${instanceId}_${ENTITY_PATH[type]}`,
        text: `${STYLED_COLUMN_TEXT_CLASSNAME}_${instanceId}_${ENTITY_PATH[type]}`,
      }
    case NAMES_OF_ENTITIES_FOR_STYLES.COLUMN:
      return {
        header: `${STYLED_COLUMN_HEADER_CLASSNAME}_${instanceId}_${ENTITY_PATH[type]}_${modifyColumnField}_field`,
        text: `${STYLED_COLUMN_TEXT_CLASSNAME}_${instanceId}_${ENTITY_PATH[type]}_${modifyColumnField}_field`,
      }
    default:
      return {
        header: '',
        text: '',
      }
  }
}

export default getClassNameGlobalStyles
